//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
import "../CAM/CAM.StepoverBuilder.js";
let d=[[[0,"CutLevelType",1,0],[1,"DistanceBelow",0,"CAM.InheritableToolDepBuilder",0],[1,"GlobalDepthPerCut",0,"CAM.StepoverBuilder",0],[0,"RangeType",1,0],[0,"TopOffCriticalDepths",1,0],[0,"TopZc",1,0]],[[[],"ApplyGlobalDepthPerCut",{},0,0],[["current_value"],"SetTopGeometry",{},1,0],[[],"InitializeData",{R_:{isUpdated:''}},0,0],[["rangeDepth","depthPerCut","measureType","referencedRange"],"AddRangeFromDepth",{R_:{index:''}},4,0],[["selectedObject","depthPerCut"],"AddRangeFromGeometry",{R_:{index:''}},2,0],[["index"],"DeleteRange",{},1,0],[["index","rangeDepth","measureType"],"SetRangeDepth",{},3,0],[["index","depthPerCut"],"SetRangeDepthPerCut",{},2,0],[["index"],"GetRangeDepthPerCut",{R_:{depthPerCut:''}},1,0],[["index","geometry"],"SetRangeGeometry",{},2,0]],[]];
SPLM.CAM.CutLevel = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.CutLevel";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.CutLevel.RangeTypes = Object.freeze({
    "Automatic" : "Automatic", "UserDefined" : "UserDefined", "Single" : "Single"});

SPLM.CAM.CutLevel.Types = Object.freeze({
    "Constant" : "Constant", "Optimized" : "Optimized", "RangeBottom" : "RangeBottom"});

SPLM.CAM.CutLevel.MeasureTypes = Object.freeze({
    "TopLevel" : "TopLevel", "RangeTop" : "RangeTop", "RangeBottom" : "RangeBottom", "WcsOrigin" : "WcsOrigin"});

export default SPLM;